export enum REMINDER_LIMIT {
  DAYS_TO_REMIND = 14,
}
